import moment from 'moment';

export default class HotelBookingRequest {

constructor(bookingInfo) {
	this.checkin = bookingInfo.locale == "en"? moment(bookingInfo.checkin).format('DD/MM/YYYY') : bookingInfo.checkin;
	this.checkout = bookingInfo.locale == "en"? moment(bookingInfo.checkout).format('DD/MM/YYYY') : bookingInfo.checkout;
	this.hotelId = bookingInfo.hotel.id;
	this.priceId = bookingInfo.price.id;
	this.roomTypeId = bookingInfo.roomType.id;
	this.supplierId = bookingInfo.price.supplierId;
	this.adultsQty = bookingInfo.adultsQty;
	this.chdAges = bookingInfo.chdAges;
	this.obs = bookingInfo.obs;
	this.rooms = this.buildRooms(bookingInfo);
}

	buildRooms(bookingInfo){
		let rooms = [];
		for(let i=0; i < bookingInfo.roomsQty; i++){
			rooms.push({
				roomTypeName: bookingInfo.roomType.name,
				roomTypeId: bookingInfo.roomType.id,
				guests: this.buildGuests(bookingInfo),
			});
		}
		return rooms;
	}

	buildGuests(bookingInfo) {
		let guests = [];
		for (let i = 0; i < bookingInfo.adultsQty; i++) {
			guests.push({ name: null, RPH: null});
		}
		return guests;
	}

	buildGuestsWithRPH(rooms) {
		let RPH = 0;
		let guests = [];
		for (var room of rooms) {
			if(room.guests)
				for (var guest of room.guests) {
					guest.RPH=RPH;
					guests.push(guest);
					RPH++;
				}
		}
		return guests;
	};
}



// WEBPACK FOOTER //
// ./src/model/HotelBookingRequest.js